import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../redux/store';
import { DealingMessageContainer } from './dealingMessageContainer';
import { FloatingTourneyHeaderContainer } from './header/floatingTourneyHeaderContainer';
import { TableStatusOverlayDisplay } from './tableStatusOverlayDisplay';
const CONTAINER_BASE_CSS = css `
  position: absolute;
  bottom: 0;
  pointer-events: none;
  max-width: 100%;
  max-height: 100%;
`;
export const DomPokerTableOverlay = () => {
    const stageDimensions = useAppSelector((state) => state.gameDimensions.stageDimensions, shallowEqual);
    if (!stageDimensions) {
        return null;
    }
    const contents = (_jsxs(_Fragment, { children: [_jsx(FloatingTourneyHeaderContainer, {}), _jsx(TableStatusOverlayDisplay, {}), _jsx(DealingMessageContainer, {})] }));
    return (_jsx("div", { css: CONTAINER_BASE_CSS, style: {
            width: `${stageDimensions.w}px`,
            height: `${stageDimensions.h}px`
        }, children: contents }));
};
